// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"145":"f6e762ed","184":"0003300d","411":"84a73982","469":"98a031da","636":"84a73982","874":"751752db"}[chunkId] + ".chunk.css";
};